import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { Subject, debounceTime, distinctUntilChanged } from 'rxjs';
import { AuthService } from 'src/app/services/auth.service';
import { QuestionnaireService } from 'src/app/services/questionnaire.service';

@Component({
    selector: 'app-questionnaire-templates',
    templateUrl: './questionnaire-templates.component.html',
    styleUrl: './questionnaire-templates.component.scss',
    standalone: false
})
export class QuestionnaireTemplatesComponent implements OnInit {
	@ViewChild('createTemplateModal') createTemplateModal!: TemplateRef<any>;
	@ViewChild('successModal') successModal!: TemplateRef<any>;

	questionnaireTemplates: any[] = [];
  currentPage: number = 1;
  pageSize: number = 8;
  total: number = 0;
  searchText: string = '';
  sortColumn: string = 'first_name';
  sortDirection: string = 'desc';

	startIndex: number = 0;
  endIndex: number = 0;

	currentUser: any = null;
	loading = true;

	createPlanModalRef: any;
	successModalRef: any;
	
	createForm!: UntypedFormGroup;
	submitted = false;
	spinner = false;
	success = false;
	message = '';

	private searchSubject = new Subject<string>();

	constructor(private questionnaireService: QuestionnaireService, private authService: AuthService) {}

	ngOnInit(): void {
		// const data = {
		// 	name: 'Standard',
		// 	description: 'Resign a landing page design. as per abc minimal design.',
		// 	active: true,
		// 	createdAt: '2024-05-19 14:13:07',
		// 	updatedAt: '2024-05-20 14:13:07'
		// }

		// this.questionnaireTemplates.push(data);
		this.currentUser = this.authService.currentUserValue;
		this.getQuestionnaireTemplates();

    // Subscribe to search input changes with debounce
    this.searchSubject.pipe(
      debounceTime(300), // Adjust debounce time as needed
      distinctUntilChanged()
    ).subscribe(() => {
      this.currentPage = 1; // Reset to first page when search text changes
      this.getQuestionnaireTemplates();
    });
	}

	getQuestionnaireTemplates() {
		this.loading = true;
    const params = {
      page: this.currentPage.toString(),
      pageSize: this.pageSize.toString(),
      searchText: this.searchText,
      sortColumn: this.sortColumn,
      sortDirection: this.sortDirection
    };

		this.questionnaireService.getClientQuestionnaireTemplates(params).subscribe({
			next: (response: any) => {
				this.questionnaireTemplates = response.questionnaireTemplates;
				this.total = response.total;
				this.calculateIndexes();
				this.loading = false;
			},
			error: (err) => {
				this.authService.toastErrorMessage(err.message ? err.message : err, 'Getting Questionnaire Templates');
			}
		});
  }

	refreshQuestionnaireTemplates() {
		this.currentPage = 1;
		this.searchText = '';
		this.getQuestionnaireTemplates();
	}

	onPageChange(page: number) {
    this.currentPage = page;
    this.getQuestionnaireTemplates();
  }

  onSearch() {
    this.searchSubject.next(this.searchText);
  }

  onSort(column: string) {
    if (this.sortColumn === column) {
      this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc';
    } else {
      this.sortColumn = column;
      this.sortDirection = 'asc';
    }
		
    this.getQuestionnaireTemplates();
  }

	calculateIndexes() {
    this.startIndex = (this.currentPage - 1) * this.pageSize + 1;
    this.endIndex = Math.min(this.currentPage * this.pageSize, this.total);
  }

	openModal(mode: string, questionnaire_template?: any) {
		// switch (mode) {
		// 	case 'create':
		// 		this.createUserModal.openModal();
		// 		break;
		// 	case 'edit':
		// 		this.createUserModal.openModal(true, user);
		// 		break;
		// }
	}
}
